import {
  type GetAttendanceVerificationResponse,
  GetAttendanceVerificationResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

export function useGetAttendanceVerification(
  facilityUserId: string,
  options: UseGetQueryOptions<GetAttendanceVerificationResponse> = {}
) {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/facilityprofile/${facilityUserId}/attendance-verification`,
    responseSchema: GetAttendanceVerificationResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_FACILITY_PROFILE_FAILED,
    },
    enabled: Boolean(facilityUserId),
    refetchOnWindowFocus: false,
    ...options,
  });
}
